import React from 'react';
import { Widget } from '../types/widget';
import { WidgetCard } from './WidgetCard';

interface MetricSectionProps {
    widgets: Widget[];
    onDelete: (widget: Widget) => void;
    onAskMore?: (contextQuery: string, contextData?: any) => void;
    renderWidget?: (widget: Widget, index: number) => React.ReactNode;
}

const MetricSection: React.FC<MetricSectionProps> = ({ 
    widgets, 
    onDelete, 
    onAskMore, 
    renderWidget 
}) => {
    if (widgets.length === 0) {
        return null;
    }

    return (
        <div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 auto-rows-[120px] gap-4 mb-8">
                {widgets.map((widget, index) => 
                    renderWidget ? (
                        renderWidget(widget, index)
                    ) : (
                        <WidgetCard
                            key={widget.id}
                            widget={widget}
                            onDelete={onDelete}
                            onAskMore={onAskMore}
                        />
                    )
                )}
            </div>
        </div>
    );
};

export default MetricSection;
